module.exports = __webpack_public_path__ + "crm_static/img/dfxlogo_72@2x.0ae28131.png";